import { AlignmentType, BorderStyle, convertInchesToTwip, LevelFormat, WidthType } from 'docx';

export const FONT_COLOR = '004B52'; // $color-sapphire-500
export const FONT_FAMILY = 'Arial';
export const MAX_IMAGE_WIDTH = 200;
export const CHECKBOX_SYMBOL = '\u2610'; // ☐
export const RADIO_SYMBOL = '\u25cb'; // ○
export const FILLED_CIRCLE_SYMBOL = '\u25cf'; // ●
export const BULLET_SYMBOL = '•';
export const DASH_SYMBOL = '-';
export const EM_SPACE = '\u2003'; // Wide space for formatting

export const DEFAULT_SPACING = {
  after: convertInchesToTwip(0.08),
  before: convertInchesToTwip(0.08),
};

export const HEADER_SPACING = {
  after: convertInchesToTwip(0.08),
  before: convertInchesToTwip(0.16),
};

export const BLOCK_SPACING = {
  after: convertInchesToTwip(0.12),
  before: convertInchesToTwip(0.2),
};

export const QUESTION_SPACING = {
  before: convertInchesToTwip(0.25),
};

export const BASE_TEXT_CONFIG = { color: FONT_COLOR, font: FONT_FAMILY, size: 22 }; // 11pt
export const SMALL_TEXT_SIZE = 18; // 9pt
export const BOLD_TEXT_CONFIG = { ...BASE_TEXT_CONFIG, bold: true };
export const OPTION_TEXT_CONFIG = { ...BASE_TEXT_CONFIG, size: SMALL_TEXT_SIZE };
export const A_CHAR_CODE = 65; // 'A'

export const INDENT_SM = convertInchesToTwip(0.4);
export const INDENT_MD = convertInchesToTwip(0.5);
export const INDENT_LG = convertInchesToTwip(0.75);

export const BORDERLESS_TABLE_CONFIG = {
  borders: {
    bottom: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    insideHorizontal: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    insideVertical: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    left: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    right: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
    top: { color: 'FFFFFF', size: 0, style: BorderStyle.NONE },
  },
  width: { size: 100, type: WidthType.PERCENTAGE },
};

export const BULLETED_LIST_CONFIG = {
  levels: [
    {
      alignment: AlignmentType.START,
      format: LevelFormat.BULLET,
      level: 0,
      style: {
        paragraph: {
          indent: { hanging: convertInchesToTwip(0.25), left: convertInchesToTwip(0.5) },
        },
        run: {
          bold: true,
          color: FONT_COLOR,
          font: FONT_FAMILY,
        },
      },
      text: '●',
    },
  ],
  reference: 'bulleted-list',
};
